/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { CloudResourceConfigurationCdcBackup } from '../models/CloudResourceConfigurationCdcBackup';
import { CloudResourceConfigurationInventoryBackup } from '../models/CloudResourceConfigurationInventoryBackup';

export class CloudResourceConfiguration {
  'cdcBackup': CloudResourceConfigurationCdcBackup;
  'inventoryBackup': CloudResourceConfigurationInventoryBackup;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "cdcBackup",
      "baseName": "cdcBackup",
      "type": "CloudResourceConfigurationCdcBackup",
      "format": ""
    },
    {
      "name": "inventoryBackup",
      "baseName": "inventoryBackup",
      "type": "CloudResourceConfigurationInventoryBackup",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return CloudResourceConfiguration.attributeTypeMap;
  }

  public constructor() {
  }
}

